import React from 'react';
import { Button, CardActions } from '@material-ui/core';
import Pagination from '@material-ui/lab/Pagination';

const PaginationButtons = ({ page, pages, onPageChange, labels }) => {
  const pageNum = Number(page) || 1;
  const pagesNum = Number(pages) || 1;

  return (
    <CardActions style={{ display: 'inline-flex' }}>
      <Button
        onClick={() => pageNum !== 1 && onPageChange(1)}
        className="pagenation"
      >
        {labels.first}
      </Button>

      <Button
        onClick={() => pageNum > 1 && onPageChange(pageNum - 1)}
        className="pagenation"
      >
        {labels.prev}
      </Button>

      <Pagination
        onChange={(event, p) => p !== pageNum && onPageChange(p)}
        page={pageNum}
        count={pagesNum}
      />

      <Button
        onClick={() => pageNum < pagesNum && onPageChange(pageNum + 1)}
        className="pagenation"
      >
        {labels.next}
      </Button>

      <Button
        onClick={() => pageNum !== pagesNum && onPageChange(pagesNum)}
        className="pagenation"
      >
        {labels.last}
      </Button>
    </CardActions>
  );
};

export default PaginationButtons;

